import React from "react"

import Stakeholder from "./stakeholder-item/Stakeholder"
import StakeholderFilterWidgetContainer from "./stakeholder-filter/StakeholderFilterWidgetContainer"
import StakeholdersListWidgetContainer from "./stakeholders-list/StakeholdersListWidgetContainer"
import pageComponent from "../common/page-component-hoc"
import { stakeholdersPageItemRequest } from "../../actions/stakeholder-actions"

type Props = {
    isFilterActive: boolean
}

const Stakeholders = ({ isFilterActive }: Props) => (
    <div id="stakeholders" className="widgets-container clearfix row">
        <div
            className="col-xs-12 col-md-6 col-lg-5 col-xl-4 widget-list"
            id="stakeholders-list"
            data-cy="stakeholdersListContainer"
        >
            {isFilterActive ? (
                <StakeholderFilterWidgetContainer />
            ) : (
                <StakeholdersListWidgetContainer />
            )}
        </div>
        <Stakeholder />
    </div>
)

export default pageComponent("stakeholders", stakeholdersPageItemRequest)(
    Stakeholders
)
